import React from "react";
import PaneHeader from "./PaneHeader";
import "./PaneHeaders.sass";

/**
 * Headers over the oscillator panes, placed from engine.getPaneLayout()
 * (events.onPaneLayoutChange), clipped to the area of the panes like the
 * panes themselves. When the panes do not fit (D24), a thin bar on the
 * right of the area shows which part of them is in view.
 *
 * @param {object}   props
 * @param {object|null} props.paneLayout - usePaneLayout
 * @param {object[]} props.indicators - engine.getIndicators() items
 * @param {boolean}  props.areTitlesHidden - ▾ of any header (or ◂ of the legend) hides all titles
 * @param {() => void} props.onToggleTitles
 * @param {(key: string, isVisible: boolean) => void} props.onSetVisible
 * @param {(key: string) => void} [props.onEdit]
 * @param {(key: string) => void} props.onRemove
 * @param {(key: string, isExpanded: boolean) => void} props.onSetExpanded
 */
const PaneHeaders = ({
  paneLayout,
  indicators,
  areTitlesHidden,
  onToggleTitles,
  onSetVisible,
  onEdit,
  onRemove,
  onSetExpanded,
}) => {
  if (!paneLayout?.panes.length || !paneLayout.areaHeight) return null;

  const { mainHeight, areaHeight, contentHeight, scrollTop, paneWidth, panes } = paneLayout;
  const isScrollable = contentHeight > areaHeight;

  return (
    <div className="pane-headers" style={{ top: mainHeight, width: paneWidth, height: areaHeight }}>
      {panes.map((pane) => {
        const indicator = indicators.find(({ key }) => key === pane.id);

        return (
          indicator && (
            <PaneHeader
              key={pane.id}
              indicator={indicator}
              pane={{ ...pane, top: pane.top - mainHeight }}
              isFolded={areTitlesHidden}
              onToggleFolded={onToggleTitles}
              onSetVisible={onSetVisible}
              onEdit={onEdit}
              onRemove={onRemove}
              onSetExpanded={onSetExpanded}
            />
          )
        );
      })}
      {isScrollable && (
        <span
          className="pane-headers__scrollbar"
          style={{
            top: (scrollTop * areaHeight) / contentHeight,
            height: (areaHeight * areaHeight) / contentHeight,
          }}
          aria-hidden="true"
        />
      )}
    </div>
  );
};

export default PaneHeaders;
